module.exports = __webpack_public_path__ + "views/editForwarder.bf9015dffb24965be5e2750777ff9416.html";